import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../reduxStore/store';

interface Coupon {
  coupon_id: string;
  coupon_code: string;
}

interface CurrentUserState {
  coupon: Coupon | null;
  loading: boolean;
  error: string | null;
}

const initialState: CurrentUserState = {
  coupon: null,
  loading: false,
  error: null,
};

interface ErrorResponse {
  message: string;
}

export const purchaseCoupon = createAsyncThunk<any, string, { rejectValue: ErrorResponse, state: RootState }>(
  'couponDetails/fetchCouponDetails',
  async (couponId, thunkAPI) => {
    const token = localStorage.getItem('accessToken');
    console.log("Token for fetching data " + token);

    if (!token) {
      return thunkAPI.rejectWithValue({ message: 'No token available' });
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await axios.post(
        `${apiUrl}${shop_domain}/api/v1/customer/coupons/${couponId}`,
        {}, // This empty object is necessary to ensure the headers are the third argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Single data " + JSON.stringify(response.data.data));
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return thunkAPI.rejectWithValue({ message: error.response.data.message || 'An error occurred' });
      }
      return thunkAPI.rejectWithValue({ message: 'An unknown error occurred' });
    }
  }
);

const userSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(purchaseCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(purchaseCoupon.fulfilled, (state, action: PayloadAction<Coupon>) => {
        state.loading = false;
        state.coupon = action.payload;
        state.error = null;
      })
      .addCase(purchaseCoupon.rejected, (state, action: PayloadAction<ErrorResponse | undefined>) => {
        state.loading = false;
        state.error = action.payload?.message || 'Unknown error';
      });
  },
});

export default userSlice.reducer;
